import { createStyles, makeStyles } from "@material-ui/core";

import { baseColors, RelodeTheme } from "..";

export const useStatsTileStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        tilesSeparator: {
            margin: theme.spacing(6, 0),
        },
        tilesContainer: {
            display: "flex",
            flexDirection: "column",
        },
        tilesSection: {
            [theme.breakpoints.down("sm")]: {
                display: "grid",
                gridRowGap: theme.spacing(2),
                gridColumnGap: theme.spacing(2),
                gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            },
        },
        sectionTitleFlex: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: theme.spacing(1),
        },
        statsSyncDate: {
            color: baseColors.gray,
        },
        notAvailableText: {
            textAlign: "left",
            width: "100%",
            marginTop: theme.spacing(3),
        },

        statisticsContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            [theme.breakpoints.down("sm")]: {
                alignItems: "unset",
                flexDirection: "column",
                marginTop: theme.spacing(2),
            },
        },
        statsContainerWrapper: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            [theme.breakpoints.down("sm")]: {
                borderLeft: "none",
            },
        },
        statsContainer2: {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(3, 6, 4, 0),
            [theme.breakpoints.down("sm")]: {
                alignItems: "center",
            },
        },
        statsContainer3: {
            display: "grid",
            gridRowGap: theme.spacing(2),
            gridColumnGap: theme.spacing(2),
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            [theme.breakpoints.down("sm")]: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            },
        },
        topBorder: {
            borderTop: "1px solid #DDDDDF",
        },
        statSectionTitle: {
            fontSize: 20,
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down("sm")]: {
                marginBottom: theme.spacing(4),
            },
        },
        badgeDot: {
            borderRadius: "30px",
            height: "8px",
            width: "8px",
            backgroundColor: baseColors.magenta,
        },

        panelIndicatorContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "baseline",
            columnGap: "4px",
        },
    })
);
